export default __webpack_public_path__ + "static/media/2083.a4721351.png";